import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { apiClient } from '@sidd/chatbot-core'
import WebDirectSite from './WebDirectSite.vue'
import './styles/main.css'

// Configure API base URL from environment variable (for local development)
const apiBaseUrl = import.meta.env.VITE_API_BASE_URL
if (apiBaseUrl) {
  apiClient.setBaseUrl(apiBaseUrl)
}

const app = createApp(WebDirectSite)
app.use(createPinia())
app.mount('#app')
